import { autoMount } from '../../../utils/autoMount';
import { HotRecruitments } from '../../../components/organisms/hotRecruitments';

autoMount({ HotRecruitments });
